const uriProduction = 'https://api.sabin.com.br'
const uriDeveloper = 'https://apidev.cloudsabin.com'
const uriStaging   = 'https://api-staging.cloudsabin.com'
const uriLocalhost = 'http://localhost:3000'

const urls = [
  { 'localhost:8080': uriLocalhost },
  { 'backofficedev.cloudsabin.com': uriDeveloper},
  { 'backoffice-staging.cloudsabin.com': uriStaging},
  { 'backoffice.sabin.com.br': uriProduction }
]

const AdminDetailService = function (Restangular) {
  const Service = Restangular.allUrl('admin/attendance_hour', urls.find(elem => elem[window.location.host])[window.location.host]);
  const ServiceAdmin = Restangular.all('admin');

  const getSquares = () => Service.customGET('region?limit=100');
  const getUnits = () => Service.customGET('unit?limit=100');
  const setRegionInUser = payload => ServiceAdmin.customPOST(payload, `admin_region`);
  const setUnitInUser = payload => ServiceAdmin.customPOST(payload, `admin_unit`);
  const updateRegionInUser = payload => ServiceAdmin.customPUT(payload.data, `admin_region/${payload.id}`);
  const updateUnitInUser = payload => ServiceAdmin.customPUT(payload.data, `admin_unit/${payload.id}`);

  return {
    getSquares,
    getUnits,
    setRegionInUser,
    setUnitInUser,
    updateRegionInUser,
    updateUnitInUser
  } ;
};

AdminDetailService.$inject = ['Restangular'];

export default AdminDetailService;



// WEBPACK FOOTER //
// ./client/app/components/admin/admin-detail.service.js